// Modules
import React from 'react';
import PropTypes from 'prop-types';
import browserHistory from 'react-router/lib/browserHistory';

// Styles
import * as styles from './CompanyCard.scss';

const CompanyCard = props => {
  const handleClick = () => browserHistory.push(props.link);

  return (
    <div onClick={handleClick} className={styles.companyCell}>
        <div className={styles.logo}>
            <img src={props.logo} alt="" />
        </div>
        <div className={styles.infoBlock}>
            <div className={styles.companyName}>
                {props.name}
            </div>
            <div className={styles.bottomBlock}>
                {!props.isBroker && !props.isRealtorsAssociation && !props.withoutCount && (
                    <div className={styles.propertiesWrapper}>
                        <div className={styles.iconProperties}>
                            <i className="icon icon-home" />
                        </div>
                        <div className={styles.count}>
                            {props.count}
                        </div>
                        <div className={styles.text}>
                            {props.translate('professionals', 'properties')}
                        </div>
                    </div>
                )}
                <div className={styles.buttonWrapper}>
                    <button onClick={handleClick}>
                        {props.translate('professionals', 'moreDetails')}
                    </button>
                </div>
            </div>
        </div>
      </div>
  );
};

CompanyCard.propTypes = {
  translate: PropTypes.func,
  name: PropTypes.string,
  logo: PropTypes.string,
  link: PropTypes.string,
  count: PropTypes.number,
  isBroker: PropTypes.bool,
  isRealtorsAssociation: PropTypes.bool,
  withoutCount: PropTypes.bool
};

export default CompanyCard;
